var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import { memo } from 'react';
import * as React from "react";
var SvgCompass24Filled = /*#__PURE__*/memo(function (props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 23c6.075 0 11-4.925 11-11S18.075 1 12 1 1 5.925 1 12s4.925 11 11 11ZM10.15 9.493l4.772-2.179c1.12-.512 2.279.608 1.765 1.767l-2.18 4.771a1.548 1.548 0 0 1-.657.657l-4.77 2.18c-1.123.513-2.28-.645-1.767-1.767l2.18-4.771c.114-.248.41-.544.658-.658Zm.907 3.45a1.333 1.333 0 1 0 1.885-1.884 1.333 1.333 0 0 0-1.885 1.884Z",
    clipRule: "evenodd"
  })));
});
SvgCompass24Filled.displayName = "SvgCompass24Filled";
export default SvgCompass24Filled;